import { render, staticRenderFns } from "./instance-name.vue?vue&type=template&id=e725509a&scoped=true"
import script from "./instance-name.vue?vue&type=script&setup=true&lang=js"
export * from "./instance-name.vue?vue&type=script&setup=true&lang=js"
import style0 from "./instance-name.vue?vue&type=style&index=0&id=e725509a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e725509a",
  null
  
)

export default component.exports